const c = {
  name: "Hands11111",
  dimensions: { width: 35, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 40" style="enable-background:new 0 0 35 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M13,2c0.8,0,1.6,0.2,2.2,0.7C15.8,1.1,17.3,0,19,0c1.7,0,3.2,1.1,3.8,2.7C23.4,2.2,24.2,2,25,2
			c2.2,0,4,1.8,4,4v0.6C29.6,6.2,30.3,6,31,6c2.3,0,4,2.1,4,4.4V27c0,7.2-5.8,13-13,13c-4.7,0-9.3-2-12.4-5.6l-6.7-7.5l-1.9-2.3
			c-1.4-1.7-1.2-4.2,0.5-5.6c1.7-1.4,4.2-1.2,5.6,0.5l2,2.1V6C9,3.8,10.8,2,13,2z M19,2c-1.1,0-2,0.9-2,2v17h4V4C21,2.9,20.1,2,19,2
			z M23,21h4V6c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2V21z M29,21h2v2H13v-2h2V6c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v20.5l-5.4-5.7l0,0
			c-0.7-0.9-2-1-2.8-0.2c-0.9,0.7-1,2-0.2,2.8l1.9,2.3l6.7,7.5C13.9,36.2,17.8,38,22,38c6.1,0,11-4.9,11-11V10.4C33,9,32,8,31,8
			s-2,1-2,2.4V21z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hands11111
};
